import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ConstantsService, LookupsService, SessionService } from '@app/core/services';
import { SocoHttpService } from '@app/soco/http';
import { LandingService } from '../../base';
import { UspsService } from '@app/shared/services';
import { BuilderInfoOne } from '@app/core/models';
import { focusFirstInvalidField, triggerFormValidation } from '@app/shared/functions';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { AlertService } from '@app/base/alerts/alert.service';

declare var swal: any;
require('sweetalert');

@Component({
  selector: 'app-builder-register',
  templateUrl: './builder-register.component.html',
  styleUrls: ['./builder-register.component.css']
})
export class BuilderRegisterComponent implements OnInit {
_validateEmail: boolean;
  registerForm: FormGroup;
  userForm: FormGroup;
  builderCompanies: any[] = [];
  alertMsg: any = [];
  companyDetailsFlag = false;
  builderId: string = null;
  cities: any = [];
  addNewUser: any = {};
  states: any = [];
  linkFlag = true;
  public addNewBuilder: BuilderInfoOne = {
    reEnterEmail : null,
    id: null,
    IsActive: null,
    _companyName: null,
    companyName: null,
    status: null,
    builderTypeCode: null,
    email: null,
    recCreateDate: null,
    recCreateUserId: null,
    recUpdateDate: null,
    recUpdateUserId: null,
    builderUsers: null,
    builderMapping: null,
    builderAddresses: {
      id: null,
      contactTypeCode: null,
      streetNumber: null,
      streetName: null,
      directionPrefix: null,
      directionSuffix: null,
      streetType: null,
      city: null,
      state: null,
      zipCode: null,
      contactName2Extn: null,
      contactName1Extn: null,
      contactName1Phone: null,
      contactName1AreaCode: null,
      contactName2AreaCode: null,
      contactName2Phone: null,
      address2: null,
      unitNumber: null,
      recUpdatedDate: null,
    recCreatedDate: null,
    recCreatedBy: null,
    recUpdatedBy: null
    }
  };
  constructor(@Inject(Router) private router: Router, public constantsSvc: ConstantsService, public sessionSvc: SessionService,
    public landingSvc: LandingService, public socoHttp: SocoHttpService, public lookupSvc: LookupsService,
    private usps: UspsService,  private datePipe: DatePipe, private alertService: AlertService) {
      this.cities = this.lookupSvc.cities;
      this.states = this.lookupSvc.states;
        // Load common lookup values
    const subscribe = this.lookupSvc.commonLookupsLoaded$.subscribe(val => {
      if (subscribe && val) {
        subscribe.unsubscribe();
      }
      // Banner message for Home page
      if (val) {
         this.alertMsg = (this.lookupSvc.bannerMessages.find( x => x.itemName === 'Builder User Register'
      ));
        this.alertService.info(this.alertMsg.message);
      }
    });
   }

  ngOnInit() {
    this.userForm = new FormGroup({
      firstName: new FormControl(
        null,
        [Validators.required, Validators.maxLength(50)]
      ),
      lastName: new FormControl(
        null,
        [Validators.required, Validators.maxLength(50)]
      ),
      email: new FormControl(
        null,
        [Validators.required, Validators.maxLength(50), Validators.pattern(this.constantsSvc.emailPattern)]
      ),
      reEnterEmail: new FormControl(
        null,
        [Validators.required, Validators.maxLength(50), Validators.pattern(this.constantsSvc.emailPattern)]
      ),
      contactNumber: new FormControl(
        null,
        [Validators.required, Validators.pattern(this.constantsSvc.phoneNumberPattern)]
      )
    });

    this.registerForm = new FormGroup({
     builderName: new FormControl(null, [Validators.required, Validators.maxLength(70)]),
     streetNumber: new FormControl(null,
       [Validators.required, Validators.maxLength(7), Validators.pattern(this.constantsSvc.numericPattern)]),
     streetName: new FormControl(null, [Validators.required,  Validators.maxLength(60)]),
     city: new FormControl({ value: null, disabled: true }),
     state: new FormControl({ value: null, disabled: true }),
     zipCode: new FormControl(null,
       [Validators.required, Validators.pattern(this.constantsSvc.zipCodePattern)]),
     phone: new FormControl(null,
       [Validators.required, Validators.pattern(this.constantsSvc.phoneNumberPattern)]),
     phoneExt: new FormControl(null,
       [Validators.pattern(this.constantsSvc.phoneNumberExtensionPattern), Validators.maxLength(6)]),
     emailCompany: new FormControl(null,
       [Validators.required, Validators.maxLength(50), Validators.pattern(this.constantsSvc.emailPattern)])
    });
    this.resolveZipCode();
  }


  resetForm() {
    this.registerForm.reset();
    this.userForm.reset();
  }

  submitForm() {
    if (this.userForm.valid) {
        if (this.registerForm.valid) {
      this.addNewBuilder._companyName = this.registerForm.controls['builderName'].value.trim();
      this.addNewBuilder.companyName = this.registerForm.controls['builderName'].value.trim();
      this.addNewBuilder.email = this.registerForm.controls['emailCompany'].value;
      this.addNewBuilder.recCreateDate = this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
      this.addNewBuilder.recUpdateDate = this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
      this.addNewBuilder.recCreateUserId =  this.userForm.controls['email'].value;
      this.addNewBuilder.recUpdateUserId = this.userForm.controls['email'].value;
      this.addNewBuilder.builderAddresses.recCreatedDate =
      this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
      this.addNewBuilder.builderAddresses.recUpdatedDate =
       this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
      this.addNewBuilder.builderAddresses.recCreatedBy =  null;
      this.addNewBuilder.builderAddresses.recUpdatedBy = null;
      this.addNewBuilder.IsActive = 'N';
      this.addNewBuilder.status = 'Requested';
      this.addNewBuilder.builderAddresses.contactTypeCode =  this.constantsSvc.contactTypeCode;
      this.addNewBuilder.builderAddresses.id = null;
      this.addNewBuilder.id = null;
      this.addNewBuilder.builderAddresses.state = this.registerForm.controls['state'].value ?
      this.registerForm.controls['state'].value.id : null;
      this.addNewBuilder.builderAddresses.city = this.registerForm.controls['city'].value ?
      this.registerForm.controls['city'].value.id : null;
      this.addNewBuilder.builderAddresses.zipCode = this.registerForm.controls['zipCode'].value;
      this.addNewBuilder.builderAddresses.streetName = this.registerForm.controls['streetName'].value.trim();
      this.addNewBuilder.builderAddresses.streetNumber = this.registerForm.controls['streetNumber'].value.trim();
      this.addNewBuilder.builderAddresses.contactName1Extn = this.registerForm.controls['phoneExt'].value;
        this.addNewBuilder.builderAddresses.contactName1Phone = this.registerForm.controls['phone'].value;
        this.addNewBuilder.builderAddresses.address2 = this.registerForm.controls['streetNumber'].value + ' ' +
        this.registerForm.controls['streetName'].value + ', ' + this.registerForm.controls['city'].value.itemName + ', ' +
        this.registerForm.controls['state'].value.itemName + ' ' + this.registerForm.controls['zipCode'].value;

        this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter1');
        this.landingSvc.getBuilderCompany(this.addNewBuilder.companyName).subscribe(res => {
          console.log(res);
          if (res.data === 0) {
            this.landingSvc.addBuilder(this.addNewBuilder).subscribe(res => {
              this.builderId = res.data.id;
              this.addUser();
            },
            error => {
              this.socoHttp.hidePleaseWait('ContainerAwaiter1');
              swal(this.constantsSvc.errorSwal1, this.constantsSvc.builderCompanyAddFail, this.constantsSvc.errorSwal);
            });
          } else {
            swal(this.constantsSvc.warningSwal, this.constantsSvc.builderCompanyAddWarning, this.constantsSvc.warningSwal);
            this.resetForm();
            this.socoHttp.hidePleaseWait('ContainerAwaiter1');
          }
        });
      } else {
        triggerFormValidation(this.registerForm);
        focusFirstInvalidField(this.registerForm);
      }
    } else {
      triggerFormValidation(this.userForm);
      focusFirstInvalidField(this.userForm);
    }
  }

  addUser() {
    this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter1');
    this.addNewUser.id = this.builderId;
    this.addNewUser.userId = this.userForm.controls['email'].value;
    this.addNewUser.userName = this.userForm.controls['firstName'].value + ' ' + this.userForm.controls['lastName'].value;
    this.addNewUser.firstName = this.userForm.controls['firstName'].value;
    this.addNewUser.lastName = this.userForm.controls['lastName'].value;
    this.addNewUser.email = this.userForm.controls['email'].value;
    this.addNewUser.reEnterEmail = this.userForm.controls['reEnterEmail'].value;
    this.addNewUser.Status = 'Requested';
    this.addNewUser.communicationTypeCd = null;
    this.addNewUser.iaAdmin = null;
    this.addNewUser.recCreatedDate = this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
    this.addNewUser.recUpdatedDate = this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
    this.addNewUser.recCreatedBy =  this.userForm.controls['email'].value;
    this.addNewUser.recUpdatedBy = this.userForm.controls['email'].value;
    this.addNewUser.contactName2Phone = this.userForm.controls['contactNumber'].value;
    this.addNewUser.contactName2Extn = null;
    this.addNewUser.comments = null;
    this.addNewUser.approveRejectDTTM = null;
    this.addNewUser.approveRejectBy = null;
    this.landingSvc.addUser(this.addNewUser).subscribe(result => {
      if (result.data.companyName === '') {
        swal(this.constantsSvc.warningSwal, this.constantsSvc.builderUserAddWarning, this.constantsSvc.warningSwal);
        this.socoHttp.hidePleaseWait('ContainerAwaiter1');
      } else {
        swal(this.constantsSvc.successSwal1, this.constantsSvc.builderUserAddSuccess, this.constantsSvc.successSwal);
        this.resetForm();
         this.router.navigate([
        this.sessionSvc.paramLdc.toLowerCase(),
        'home'
      ]);
        this.socoHttp.hidePleaseWait('ContainerAwaiter1');
      }
    }, error => {
      swal(this.constantsSvc.errorSwal1, this.constantsSvc.builderUserAddFail, this.constantsSvc.errorSwal);
      this.resetForm();
      this.socoHttp.hidePleaseWait('ContainerAwaiter1');
    });

  }

  validateEmail() {
    const email = this.userForm.controls['email'].value;
    const reEnterEmail = this.userForm.controls['reEnterEmail'].value;
    if (email !== null && reEnterEmail !== null) {
      if (email === reEnterEmail) {
        this._validateEmail = false;
        return { reEnterEmailAddress: { validateEmail: false } };

      } else {
        this.userForm.controls['reEnterEmail'].setErrors({ validateEmail: true });
        this._validateEmail = true;
      }
    }
  }
   // Code to populate city and state values based on zip code entered
   resolveZipCode() {
    this.registerForm.controls['zipCode'].valueChanges.subscribe(selectedValue => {
      if (this.constantsSvc.zipCodePattern.test(selectedValue)) { // We have a valid ZIP Code.
        this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter1');
        this.usps.GetCityStateFromZip(selectedValue, (result) => {
          if (result.CityStateLookupResponse.ZipCode.Error) {
            this.registerForm.patchValue({ city: null, state: null, zipCode: null });
            this.socoHttp.hidePleaseWait('ContainerAwaiter1');
            swal(this.constantsSvc.invalidZipSwal, '', this.constantsSvc.errorSwal);
            return;
          }
          this.lookupSvc.loadMailingAddressCityLookups(result.CityStateLookupResponse.ZipCode.State,
            result.CityStateLookupResponse.ZipCode.City);
          this.lookupSvc.mailingAddressLookupsLoaded$.subscribe(loaded => {
            if (loaded) {
              this.socoHttp.hidePleaseWait('ContainerAwaiter1');
              this.cities = this.lookupSvc.mailingCity;
              this.states = this.lookupSvc.mailingState;
              this.registerForm.patchValue({
                city: this.lookupSvc.mailingCity.length > 0 ? this.lookupSvc.mailingCity[0] : null,
                state: this.lookupSvc.mailingState.length > 0 ? this.lookupSvc.mailingState[0] : null,
              });
            }
          }, fail => { this.socoHttp.hidePleaseWait('ContainerAwaiter1'); });
        });
      }
    });
  }
}
